"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    sprinxFormsValidation: {
      required: 'Pole je povinné!',
      string: 'Musí byť textový reťazec!',
      stringEmpty: 'Nesmie byť prázdne!',
      stringMin: 'Dĺžka musí byť väčšia alebo rovná dĺžke {expected} znakov!',
      stringMax: 'Dĺžka musí byť menšia alebo rovná dĺžke {expected} znakov!',
      stringLength: 'Dĺžka musí byť {expected} znakov dlhá!',
      stringPattern: 'Nesplňuje požadovaný vzor!',
      stringContains: "Musí obsahovať text '{expected} '!",
      stringEnum: 'Nezodpovedá žiadnej z povolených hodnôt!',
      number: 'Musí to byť číslo!',
      numberMin: 'Musí byť väčšie alebo rovné {expected}!',
      numberMax: 'Musí byť menšie alebo rovné {expected}!',
      numberEqual: 'Musí byť rovné s {expected}!',
      numberNotEqual: 'Nemôže byť rovné s {expected}!',
      numberInteger: 'Musí byť celé číslo!',
      numberPositive: 'Musí byť kladné číslo!',
      numberNegative: 'Musí byť záporné číslo!',
      array: 'Musí to byť zoznam!',
      arrayEmpty: 'Nesmie byť prázdny zoznam!',
      arrayMin: 'Je vyžadovaná aspoň {number, plural, one {1 položka} few {{number} položky} other {{number} položiek}}!',
      arrayMax: 'Nemôže obsahovať viac než {number, plural, one {1 položku} few {{number} položky} other {{number} položiek}}!',
      arrayLength: 'Musí obsahovať presne {expected, plural, one {1 položku} few {{number} položky} other {{number} položiek}}!',
      arrayContains: "Musí obsahovať položku '{expected}'!",
      arrayEnum: "Hodnota '{expected}' nezodpovedá žiadnej z povolených hodnôt!",
      boolean: "Musí byť 'áno' alebo 'nie'!",
      function: 'Musí byť funkcia!',
      date: 'Musí byť dátum!',
      dateMin: 'Musí byť väčší alebo rovný {expected}!',
      dateMax: 'Musí byť menší alebo rovný {expected}!',
      forbidden: 'Pole je zakázané!',
      email: 'Nevalidný e-mail!',
      url: 'Nevalidná URL!',
      object: 'Musí byť typu Object!',
      arrayReducedEquals: 'Sumarizovaná hodnota nezodpovedá {expected}!',
      phoneNumber: "Musí byť platné telefónne číslo v medzinárodnom formáte '+ XXX XXX XXX XXX '!",
      dateGt: 'Dátum musí byť väčší ako {expected}!',
      dateGte: 'Dátum musí byť väčtší alebo rovný {expected}!',
      dateLt: 'Dátum musí byť menší ako {expected}!',
      dateLte: 'Dátum musí byť menší alebo rovný {expected}!'
    }
  }
};
var _default = messages;
exports.default = _default;